import React from 'react';
import { FadeIn, Button, Section, FloralSeparator } from '../ui/Shared';
export const UrgencyBar = () => <div className="sticky top-0 z-50 bg-pink-primary text-white py-2 px-4 text-center text-sm md:text-base font-body shadow-md" style={{
  width: "953px",
  height: "55px"
}} data-id="element-1" data-mp="2kb0qzlouzpmq">
    <p className="animate-pulse-soft" data-id="element-2" data-mp="2u1lw7rz1fsem">
      ✨ OFERTA POR TIEMPO LIMITADO — Solo por hoy: <strong data-id="element-3" data-mp="2u3euojzhz6bj">$19.999 ARS</strong>{' '}
      (antes $49.900){' '}
      <span className="hidden md:inline" data-id="element-4" data-mp="1wf4zooy4pitx">
        {' '}
        | Entrega inmediata a tu correo | 7 días de garantía total
      </span>{' '}
      ✨
    </p>
  </div>;
export const HeroSection = () => <section className="relative pt-10 pb-10 px-4 overflow-hidden bg-gradient-to-b from-pink-light via-white to-celeste-light" data-id="element-5" data-mp="26b84y3oa1xl3">
    {/* Decorative background elements */}
    <div className="absolute top-10 left-10 text-pink-primary/20 text-6xl blur-[2px] rotate-12" data-id="element-6" data-mp="3hrpqv9u90hth">
      🌸
    </div>
    <div className="absolute bottom-20 right-10 text-celeste-primary/30 text-6xl blur-[1px] -rotate-12" data-id="element-7" data-mp="3lrqffnb2a9e9">
      ✨
    </div>

    <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-8" data-mp="251s89jlrzfma">
      <FadeIn data-id="element-9" data-mp="202xr0m3ghz4a">
        <p className="font-heading italic text-xl md:text-2xl text-celeste-deep mb-3" data-id="element-10" data-mp="204ilkbprti25">
          — Para la mamá que sonríe hacia afuera pero por dentro está agotada —
        </p>
        <h1 className="text-5xl md:text-7xl font-bold text-pink-deep mb-4 leading-tight text-balance" style={{
        fontSize: "40px"
      }} data-id="element-11" data-mp="1r3annur62j8l">
          Hoy empieza tu regreso a vos misma.
        </h1>

        {/* Product image */}
        <div className="max-w-sm md:max-w-md mx-auto mb-4" data-id="element-12" data-mp="1hb4tqfhctrqr">
          <img src="https://cdn.magicpatterns.com/uploads/uRf3NDZHdwbat5tQQ2nVPJ/WhatsApp_Image_2026-03-15_at_17.08.59_(2).jpg" alt="Renacer Después del Parto — Tomo 1 y Tomo 2" className="rounded-2xl shadow-xl w-full object-cover" style={{
          width: "392px",
          height: "365px"
        }} data-id="element-13" data-mp="1ccv0wbj3r38b" />
        </div>

        
      </FadeIn>

      <FadeIn delay={0.2} data-id="element-14" data-mp="yewqtibtdsym">
        <p className="text-lg md:text-xl mb-2 font-medium" data-id="element-15" data-mp="yen5w95mmbzs"></p>
        <p className="text-lg md:text-xl italic text-brown-text/80 mb-4 max-w-3xl mx-auto" style={{
        fontSize: "15px",
        color: "#171616"
      }} data-id="element-16" data-mp="op6j3sdr7an9">
          Renacer Después del Parto es el método paso a paso que te acompaña a
          recuperar tu estabilidad emocional, tu descanso y tu paz interior en 4
          semanas.
        </p>
      </FadeIn>

      <FadeIn delay={0.4} data-id="element-17" data-mp="17gr1y2o344nh">
        

        <div className="flex flex-col items-center" data-id="element-18" data-mp="17hsde890it5q">
          <Button href="#comprar" className="w-full sm:w-auto text-xl py-5 px-10 mb-2" data-id="element-19" data-mp="1cfu3ve8rpur8">
            SÍ, QUIERO EMPEZAR MI RENACER
          </Button>
          <p className="text-sm text-brown-text/70" data-id="element-20" data-mp="xq4nwcw0nm6w">
            ↓ Acceso inmediato · Entrega a tu correo · Sin esperas ↓
          </p>
        </div>
      <div className="inline-block bg-white/60 backdrop-blur-sm px-6 py-3 rounded-full border border-pink-border mb-4" style={{
        width: "492px",
        height: "41px"
      }} data-id="element-21" data-mp="1qfled502st0h">
          <p className="text-sm md:text-base font-medium text-pink-deep" style={{
          fontSize: "11px"
        }} data-id="element-22" data-mp="1v7wgmeiagqw7">
            🌸 2 Tomos Completos + 4 Bonos Exclusivos · 100% Digital · Acceso
            Inmediato
          </p>
        </div></FadeIn>
    </div>
  </section>;
export const PainRecognition = () => <Section className="bg-cream text-center" data-id="element-23" data-mp="3ooisceo7nosz">
    <FadeIn data-id="element-24" data-mp="3knp8pxhsww5w">
      <FloralSeparator data-id="element-25" data-mp="3kn72c81fd1k9" />
      <h2 className="text-3xl md:text-4xl italic mb-6" data-id="element-26" data-mp="3koqilyn2zcm1">
        ¿Reconocés alguna de estas sensaciones?
      </h2>

      <div className="max-w-2xl mx-auto space-y-5 text-lg md:text-xl" data-id="element-27" data-mp="2wy4olb9wvsv1">
        <p className="font-bold text-2xl text-pink-deep" data-id="element-28" data-mp="2rztcsv0238a6">
          Sonreís cuando alguien te mira.
          <br data-id="element-29" data-mp="35zm3iqbl1oi5" />
          Pero por dentro sentís que algo no está bien.
        </p>

        <div className="space-y-3 text-brown-text/90" data-id="element-30" data-mp="30z6nts3tw4x0">
          <p data-id="element-31" data-mp="311svrsumsmfr">El cansancio que sentís no es solo físico.</p>
          <p data-id="element-32" data-mp="l70oeibk71xu">Es un peso en el pecho que no se va con dormir.</p>
          <p data-id="element-33" data-mp="g9h9dg71el4u">
            Es la voz que aparece de noche preguntando si estás haciéndolo bien.
          </p>
          <p data-id="element-34" data-mp="1bjxa2nrh1m2x">
            Es el llanto que viene sin aviso — y la culpa que viene después.
          </p>
        </div>

        <div className="italic text-brown-text/80 py-4" data-id="element-35" data-mp="1gjjmiuzh6yao">
          <p data-id="element-36" data-mp="1lhl8bnoadbpu">Cada mañana te prometés que hoy va a ser diferente.</p>
          <p data-id="element-37" data-mp="1lga27h7dbrvk">Más paciente. Más presente. Más vos.</p>
          <p data-id="element-38" data-mp="1qh7lxy810tz6">Y al caer la noche, el agotamiento vuelve.</p>
          <p data-id="element-39" data-mp="1qeldlwdbaafw">Y con él, el pensamiento que más duele:</p>
        </div>

        <h3 className="text-2xl md:text-3xl font-heading font-bold text-celeste-deep my-5" data-id="element-40" data-mp="1uhhy5smewgmh">
          "Esto debería ser el momento más feliz de mi vida... ¿Por qué no lo
          siento así?"
        </h3>

        <p className="font-medium" data-id="element-41" data-mp="248l16zywj5oe">
          Si algo de esto resuena en vos, quiero que sepas algo importante:
        </p>

        <div className="bg-pink-light/50 p-5 rounded-2xl border border-pink-border my-5" data-id="element-42" data-mp="2990e5qf9ub5u">
          <p className="text-2xl font-heading font-bold text-pink-deep" data-id="element-43" data-mp="2e45ywlwxtjsc">
            No estás fallando. No estás rota. No sos menos mamá.
          </p>
        </div>

        <div className="space-y-2" data-id="element-44" data-mp="6la6jbql0d0v">
          <p data-id="element-45" data-mp="6ieajsyanyf2">Lo que estás viviendo tiene un nombre.</p>
          <p data-id="element-46" data-mp="2huaagifceop">Tiene una explicación científica y emocional.</p>
          <p className="font-bold text-pink-deep" data-id="element-47" data-mp="3tp6r2ufeaq43">Y tiene una salida real.</p>
        </div>
      </div>
      <FloralSeparator data-id="element-48" data-mp="3oqder5buh55i" />
    </FadeIn>
  </Section>;